// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__31dle","inner":"Footer_inner__1tClq"};